import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import logo from 'assets/img/logo-white-full.png';
import LinkValidateEmailForm from '../LinkValidateEmailForm';

type ViewProps = {
  onSubmit: ( values: { email: string } ) => void;
};

function LinkValidateEmailView( { onSubmit }: ViewProps ) {
  return (
    <Container fluid className="p-lg-0 body-onboarding-container">
      <Row className="vh-100 g-lg-0">

        <Col lg="auto" className="d-none d-lg-flex bg-blue">
          <img src={logo} alt="Grupo Impar" height={38} />
          <div className="blue-bg-img" />
        </Col>

        <Col lg className="bg-image">
          <Row className="h-100 g-lg-0">
            <Col lg={{ span: 10, offset: 1 }} xl={{ span: 7, offset: 1 }} className="my-auto">
              <div className="card--light">
                <LinkValidateEmailForm onSubmit={onSubmit} />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default LinkValidateEmailView;
